
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 17a1 1 0 011 1v3a1 1 0 01-1 1H9a1 1 0 01-1-1v-3a1 1 0 011-1h6zm-8.75-5.75a.75.75 0 110 1.5H4.579a1 1 0 00-1 1v4a1 1 0 001 1H6.25a.75.75 0 110 1.5H4a2 2 0 01-2-2v-5a2 2 0 012-2h2.25zM15 9.5a1 1 0 011 1v3a1 1 0 01-1 1H9a1 1 0 01-1-1v-3a1 1 0 011-1h6zm2.75-5.75H20a2 2 0 011.995 1.85l.005.15v5a2 2 0 01-1.85 1.995l-.15.005h-2.25a.75.75 0 01-.102-1.493l.102-.007h1.671a1 1 0 00.993-.883l.007-.117v-4a1 1 0 00-.883-.993l-.117-.007H17.75a.75.75 0 01-.102-1.493l.102-.007H20zM15 2a1 1 0 011 1v3a1 1 0 01-1 1H9a1 1 0 01-1-1V3a1 1 0 011-1h6z"}})])
          )
        }
      }
    